import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Make sure dyn bound video elements don't have any static video embed props
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const hasDynBoundHtml = DomTypeUtils.isDynBoundHtml(data);
  const hasStaticVideoEmbedUrl = Boolean(data.embed && data.embed.url);
  const hasStaticVideoEmbedMeta = Boolean(data.embed && data.embed.meta);
  const hasVProp = jsonNode.hasOwnProperty('v');

  return {
    needed:
      hasDynBoundHtml &&
      (hasVProp || hasStaticVideoEmbedUrl || hasStaticVideoEmbedMeta),
    logData: {
      msg: `DynBound video node with static data`,
      meta: {
        hasDynBoundHtml,
        hasStaticVideoEmbedUrl,
        hasStaticVideoEmbedMeta,
        v: jsonNode.v,
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (hasVProp) {
        // eslint-disable-next-line webflow/no-delete
        delete jsonNode.v;
      }

      if (hasStaticVideoEmbedUrl) {
        data.embed.url = null;
      }

      if (hasStaticVideoEmbedMeta) {
        // eslint-disable-next-line webflow/no-delete
        delete data.embed.meta;
      }
    },
  };
};
